import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import {ICom0101P3State, IDeptTreeState, IInquiryCndsState, ITargetItemState, IUserItemState} from '../../models/com/com0101p3_model';
  
const initialState: ICom0101P3State = {
    deptTree : [],
    userList : [],
    targetList : [],
    treeKey : '',
    maxLvlCd : '',

    /* 조회조건 */
    inquiryCnds: {
        deptCd : '',     // 부서코드
        userStCd : 'A'   // 부서상태코드
    },
}

export const com0101p3_Slice = createSlice({
    name: "com0101p3_Slice",
    initialState: initialState,
    reducers: {
        setInquiryCnds: (state, action:PayloadAction<IInquiryCndsState>) => {
            state.inquiryCnds = action.payload;
        },
        setDeptTree: (state, action:PayloadAction<IDeptTreeState[]>) => {
            state.deptTree = action.payload;
        },
        setUserList: (state, action:PayloadAction<IUserItemState[]>) => {
            state.userList = action.payload;
        },
        setTargetList: (state, action:PayloadAction<ITargetItemState[]>) => {
            state.targetList = action.payload;
        },
        setTreeKey: (state, action:PayloadAction<string>) => {
            state.treeKey = action.payload;
        },
        setMaxLvlCd: (state, action:PayloadAction<string>) => {
            state.maxLvlCd = action.payload;
        },
    },
});

export default com0101p3_Slice.reducer;
export const Com0101p3Action  = com0101p3_Slice.actions;
export const Com0101p3Reducer = com0101p3_Slice.reducer;